import { CONTENT, type DorBlock } from "@/content";
import { Reveal, RevealWords } from "../ui/Reveal";
import { CTABand } from "../ui/CTABand";
import { useState } from "react";
import { UberlandiaMap } from "./UberlandiaMap";

type Props = { onCTA: () => void };

import { motion } from "framer-motion";
import { AlertCircle } from "lucide-react";

function Col({ data, n, expanded }: { data: DorBlock; n: string; expanded: boolean }) {
  const items = expanded ? data.items : data.items.slice(0, 3);
  return (
    <div className="dor-col">
      <h3 className="dor-col-head">
        <span className="kicker-num">{n}</span> {data.head}
      </h3>
      <div className="dor-grid">
        {items.map(([k, v], i) => (
          <motion.div 
            key={k} 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="dor-card"
            whileHover={{ y: -4, scale: 1.01 }}
            transition={{ type: "spring", stiffness: 400, damping: 25, delay: (i % 3) * 0.1 }}
          >
            <div className="dor-card-icon">
              <AlertCircle size={20} strokeWidth={2.5} />
            </div>
            <div className="dor-card-content">
              <span className="dor-card-k">{k}</span>
              <span className="dor-card-v">{v}</span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export function Dor({ onCTA }: Props) {
  const d = CONTENT.dor;
  const [expanded, setExpanded] = useState(false);
  return (
    <section className="section dor" id="dor">
      <div className="wrap">
        <div className="dor-header-split">
          <div className="dor-header-text">
            <Reveal>
              <span className="eyebrow" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                <span className="pulse-dot"></span>
                {d.label}
              </span>
            </Reveal>
            <Reveal delay={1}>
              <h2 className="dor-title-pro">{d.title}</h2>
            </Reveal>
            <Reveal delay={2} className="dor-intro-pro">
              {d.intro.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </Reveal>
          </div>
          <Reveal delay={2} className="dor-header-map">
            <UberlandiaMap />
          </Reveal>
        </div>

        <Reveal className="dor-block-title-wrap">
          <h3 className="dor-block-title serif">{d.blockTitle}</h3>
        </Reveal>

        <div className="dor-cols">
          <Reveal delay={1}>
            <Col data={d.student} n="01" expanded={expanded} />
          </Reveal>
          <Reveal delay={2}>
            <Col data={d.professional} n="02" expanded={expanded} />
          </Reveal>
        </div>

        <Reveal className="dor-more">
          <button className="btn btn-ghost" type="button" onClick={() => setExpanded((v) => !v)}>
            {expanded ? "Ver menos" : "Ver todos os pontos"} <span className="arr">→</span>
          </button>
        </Reveal>

        <div className="dor-foot">
          <CTABand lines={d.closing} cta={d.cta} onCTA={onCTA} />
        </div>
      </div>
    </section>
  );
}
